import { useMemo, useState } from "react"

import { App } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ExportDataModal from "../../../../Components/ExportDataModal/ExportDataModal"
import { getExportPeriodLabel } from "../../../../Components/ExportDataModal/getExportPeriodLabel"
import { getCompareParams } from "../../../../Components/Filters/CompareSelect/presets"
import { getApiErrorMessage } from "../../../../Utils/thunkHelpers"
import { getDates } from "../../../../Utils/utils"
import * as services from "../../services"

const EXPORT_TABLES = [
  {
    key: "overview",
    label: "Health Overview page",
    tooltip:
      "Summary of all overview data for the selected period. For more detail, export individual data tables",
    forbiddenFormatsWhenAlone: ["csv"]
  },
  { key: "payment_method", label: "Breakdown by Payment Method" },
  { key: "reason_code", label: "Breakdown by Reason Code" },
  { key: "country", label: "Breakdown by Country" },
  { key: "prevention_rate", label: "Chargeback Prevention Rate" },
  { key: "olympics", label: "Chargeback Olympics" },
  { key: "risk_level", label: "Processor Risk Level" }
]

const EXPORT_FORMATS = [
  { value: "pdf", label: "PDF" },
  { value: "csv", label: "CSV" }
]

const ExportHealthOverviewModal = ({
  open,
  onClose,
  filters,
  businessAccountId,
  dataSource,
  isAdmin
}) => {
  const { t } = useTranslation()
  const { notification } = App.useApp()
  const lang = useSelector((state) => state?.auth?.userInfo?.language) || "en"
  const [exporting, setExporting] = useState(false)

  const periodLabel = useMemo(() => getExportPeriodLabel(filters, { lang, t }), [filters, lang, t])

  const handleExport = async ({ tables, format }) => {
    setExporting(true)
    try {
      const periodDates = getDates(filters?.period)
      const compareParams = getCompareParams(filters?.compare, periodDates)

      const response = await services.getHealthOverviewExport({
        tables,
        format,
        ...periodDates,
        ...compareParams,
        source: dataSource,
        ...(isAdmin ? { business_account: businessAccountId } : {})
      })

      if (!response.ok) {
        notification.error({ message: await getApiErrorMessage(response) })
        return
      }

      notification.success({ message: response.data?.message })
      onClose()
    } finally {
      setExporting(false)
    }
  }

  return (
    <ExportDataModal
      open={open}
      onClose={onClose}
      onExport={handleExport}
      exporting={exporting}
      periodLabel={periodLabel}
      tables={EXPORT_TABLES}
      formats={EXPORT_FORMATS}
    />
  )
}

export default ExportHealthOverviewModal
